<mat-label>{{label}}</mat-label>
<mat-form-field appearance="outline" class="form__field">
  <input matInput type="text" [placeholder]="placeholder">
</mat-form-field>
